import { render, staticRenderFns } from "./Servicer.vue?vue&type=template&id=03ac7a44&scoped=true&"
import script from "./Servicer.vue?vue&type=script&lang=js&"
export * from "./Servicer.vue?vue&type=script&lang=js&"
import style0 from "./Servicer.vue?vue&type=style&index=0&id=03ac7a44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ac7a44",
  null
  
)

export default component.exports